export function seatAngle(index: number, total: number): number {
  const humanOffset = Math.PI / 2;
  return humanOffset + (index / total) * Math.PI * 2;
}

export function seatPositionPercent(
  index: number,
  total: number,
  radiusPercent = 38,
): { left: string; top: string } {
  const angle = seatAngle(index, total);
  const x = 50 + Math.cos(angle) * radiusPercent;
  const y = 50 + Math.sin(angle) * radiusPercent;
  return { left: `${x}%`, top: `${y}%` };
}

export function seatRotationDeg(index: number, total: number): number {
  return (seatAngle(index, total) * 180) / Math.PI + 180;
}
